export default __webpack_public_path__ + "static/media/login.728a3620.png";